import { createAction } from '@reduxjs/toolkit';

/**
 * Lives alone so `baseQuery` can dispatch it without importing `authSlice`,
 * which imports `apiSlice`, which imports `baseQuery`. A three-line file beats
 * a circular import.
 */
export const loggedOut = createAction('auth/loggedOut');
